<template>
  <div>
    <template v-if="hasComponent(typeToComponentName(annotation.type))">
      <component
        :is="loadedComponents[typeToComponentName(annotation.type)]"
        :annotation="annotation"
      />
    </template>
  </div>
</template>

<script lang="ts">
import { defineAsyncComponent } from "vue";
import type { Component } from "vue";
import { pathToFileName } from "@/utils/path";

function loadAnnotationComponents(): Record<string, Component> {
  const components = import.meta.glob<{ default: Component }>(
    "/src/components/Core/Annotations/AutomatedAnnotationDescriptions/*.vue",
  );
  return Object.fromEntries(
    Object.entries(components)
      .map(([path, component]) => {
        return [pathToFileName(path), defineAsyncComponent(component)] as const;
      })
      .filter(
        ([path, _]) =>
          !["AutomatedAnnotationDescription", "Base"].includes(path),
      ),
  );
}
const loadedComponents = loadAnnotationComponents();
</script>

<script setup lang="ts">
import * as lodash from "lodash-es";
import { PropType } from "vue";
import {
  AutomatedAnnotation,
  AutomatedAnnotationType,
} from "@/services/annotation";

defineProps({
  annotation: {
    type: Object as PropType<AutomatedAnnotation>,
    required: true,
  },
});

function typeToComponentName(type: AutomatedAnnotationType): string {
  return lodash
    .startCase(type as string)
    .split(" ")
    .join("");
}

function hasComponent(name: string): boolean {
  return (
    loadedComponents[name] !== undefined && loadedComponents[name] !== null
  );
}
</script>
